module.exports = __webpack_public_path__ + "static/media/paw.616422d9.svg";